import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import onboardingService from '../services/onboarding.service';

const LoadingFallback = () => (
  <div className="flex h-screen items-center justify-center bg-background">
    <div className="text-center">
      <div className="mx-auto h-12 w-12 animate-spin rounded-full border-4 border-ring border-t-transparent" />
      <p className="mt-4 text-muted-foreground">Loading workspace…</p>
    </div>
  </div>
);

export const RequireOnboardingComplete: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const [checking, setChecking] = useState(true);
  const [complete, setComplete] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const status = await onboardingService.getStatus();
        if (!cancelled) setComplete(status.isComplete);
      } catch {
        if (!cancelled) setComplete(false);
      } finally {
        if (!cancelled) setChecking(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [location.pathname]);

  if (checking) return <LoadingFallback />;
  if (!complete) return <Navigate to="/onboarding" replace state={{ from: location.pathname }} />;
  return <>{children}</>;
};

export default RequireOnboardingComplete;
